import $ from 'jquery'

export class CalculatorMaternity {

  constructor() {
    this.$container = $('.calculator-maternity')

    if (!this.$container.length) return

    console.log('init maternity calculator')
    this.$form = this.$container.find('form')
    this.$birthDate = this.$form.find('#maternity-birth-date')
    this.$weeks = this.$form.find('#maternity-weeks')
    this.$base = this.$form.find('#maternity-base')

    this.$until = this.$container.find('#maternity-text-until')
    this.$amount = this.$container.find('#maternity-text-amount')
    this.$warning = this.$container.find('#maternity-warning')
    this.$error = this.$container.find('.calc-error')
    this.$containerWithResult = this.$container.find('.with-results')
    this.$containerWithoutResult = this.$container.find('.no-result')

    // read limits from data attributes
    const baseMinAttr = parseFloat(this.$container.attr('data-base-min'))
    const baseMaxAttr = parseFloat(this.$container.attr('data-base-max'))
    this.baseLimits = {
      min: Number.isFinite(baseMinAttr) ? baseMinAttr : 950.98,
      max: Number.isFinite(baseMaxAttr) ? baseMaxAttr : 4720.5
    }

    // warning text from data attribute
    this.warningText = this.$warning.attr('data-text') || ''

    this.$form.on('change', this.handleChangeForm.bind(this))
    this.$form.on('input', this.handleChangeForm.bind(this))
    this.$form.find('input, select').on('change input keyup', this.handleChangeForm.bind(this))

    // run calculation on load
    this.handleChangeForm()
  }

  handleChangeForm(e) {
    if (e && e.preventDefault) e.preventDefault()

    this.$containerWithResult.show()
    this.$containerWithoutResult.hide()

    let base = this.toFloat(this.$base.val())
    let weeks = this.toInt(this.$weeks.val())
    let birth = this.$birthDate.val()

    // validate base
    if (base < this.baseLimits.min || base > this.baseLimits.max) {
      this.$error.show()
      this.applyValue(this.$amount, '—')
      this.$until.text('—')
      this.$warning.text('')
      return
    }

    this.$error.hide()

    if (weeks <= 0) {
      this.$containerWithResult.hide()
      this.$containerWithoutResult.show()
      this.$warning.text('')
      return
    }

    // calculations: 100% of base during maternity
    let drb = base / 30 // daily
    let weekly = drb * 7
    let total = this.round2(weekly * weeks)

    // end date: only if birth date is set
    if (birth) {
      let endDate = this.computeEndDate(birth, weeks)
      this.$until.text(endDate)
    } else {
      this.$until.text('-')
    }

    this.applyValue(this.$amount, total)

    // warning if less than 6 weeks
    if (weeks < 6) {
      this.$warning.text(this.warningText)
    } else {
      this.$warning.text('')
    }

    console.log('base', base, 'weeks', weeks, 'drb', drb, 'weekly', weekly, 'total', total)
  }

  computeEndDate(birthIso, weeks) {
    let d = new Date(birthIso)
    if (isNaN(d.getTime())) return '—'
    d.setDate(d.getDate() + weeks * 7)
    return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })
  }

  toInt(v) {
    let n = parseInt(String(v), 10)
    return Number.isFinite(n) ? n : 0
  }

  toFloat(v) {
    let n = parseFloat(String(v))
    return Number.isFinite(n) ? n : 0
  }

  round2(n) {
    return Math.round((n + Number.EPSILON) * 100) / 100
  }

  applyValue($el, value) {
    if (!$el || !$el.length) return
    let template = $el.data('value') || '%%value%%'
    $el.text(String(template).replace('%%value%%', value))
  }
}
